/** Random delay for staggering tabs / timers (0..max ms inclusive). */
export function randomJitterMs(max = 2000): number {
  return Math.floor(Math.random() * (max + 1));
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
